import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  DELETE_LINKED_PARTNER_ACCOUNT,
  DELETE_LINKED_PARTNER_ACCOUNT_SUCCESS,
  DELETE_LINKED_PARTNER_ACCOUNT_FAILED,
} from '../../constants';

import { fetchAccountOverview } from '../../actions/account-actions';

import store from '../../store';

const deleteLinkedPartnerAccount = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_LINKED_PARTNER_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/partners/${action.clientId}?v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        method: 'DELETE',
      }).pipe(
        map(response => {
          store.dispatch(fetchAccountOverview());
          return {
            type: DELETE_LINKED_PARTNER_ACCOUNT_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: DELETE_LINKED_PARTNER_ACCOUNT_FAILED,
            error,
          })
        )
      )
    )
  );

export default deleteLinkedPartnerAccount;
